<template>
    <div>
        <el-dialog
            title="编辑优选公寓"
            :visible.sync="showoptimizationpicker"
            width="1100px"
            :before-close="close"
            append-to-body>
            <el-form :model="form" ref="form" label-width="80px" :inline="true" size="small">
                <el-form-item label="片区名称">
                    <el-input v-model="form.name" placeholder="请填写片区名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="add" icon="el-icon-plus">添加片区</el-button>
                    <el-button type="primary" @click="confirm" icon="el-icon-upload">保存优选公寓</el-button>
                </el-form-item>
            </el-form>
            
            <el-collapse v-model="activeName" accordion>
                <el-collapse-item class="op-cell" v-for="(item, index) in optimizations"
                    :key="index"
                    :title="item.name"
                    :name="index">
                    <!-- content -->
                    <template slot="title">
                        <!-- <p class="text">{{item.name}}</p> -->
                        <el-input class="custom-input" v-model="item.name" placeholder="" size="mini" clearable></el-input>
                        <el-button class="del-btn" type="danger" size="mini" @click.stop="deleteop(item, index)" icon="el-icon-delete" circle></el-button>
                    </template>
                    <div class="project-box">
                        <p class="text">关联楼盘</p>
                        <el-button class="addbtn" type="success" size="mini" @click="addproject(index)" icon="el-icon-plus">添加楼盘</el-button>
                        <el-row class="project-warp">
                            <el-col class="project-cell flex-box" :span="12" v-for="(project, ind) in item.projects" :key="ind">
                                <el-input class="custom-input" v-model="project.projectname" placeholder="请点击右侧选择楼盘按钮关联楼盘" size="mini" clearable readonly></el-input>
                                <tutor-project @getProject="getProject($event, index, ind)" v-if="regions" :regions="regions"></tutor-project>
                                <el-button class="del-btn" type="warning" size="mini" @click="deleteproject(index, ind)" icon="el-icon-delete" circle></el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="qr-box">
                        <el-upload
                            class="avatar-uploader"
                            action="/api/Upload/uploadFile/"
                            :show-file-list="false"
                            :on-success="(response)=>{handleAvatarSuccess(index,response)}"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="item.qrcode" :src="item.qrcode" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <el-footer height="80px">
                <!-- Footer content -->
            </el-footer>
        </el-dialog>
        
    </div>
</template>

<script>
import tutorProject from '../tutor-project';
export default {
    components: {
        tutorProject,
    },
    data() {
        return {
            optimizations: [],
            regions: [],
            activeName: 0,
            form: {
                name: '',
                projects: [
                    {projectname: '', projectid: ''},
                ],
                qrcode: '',
            },
        }
    },
    props: {
        acid: {
            type: String,
            default: '',
        },
    },
    mounted () {
        this.getoptimizations();
        this.getCityList();
    },
    computed: {
        showoptimizationpicker: {
            get() {
                return this.$store.getters.getshowoptimizationpicker;
            },
            set(val) {
                this.$store.commit('setshowoptimizationpicker', val);
            },
        }
    },
    methods: {
        deleteproject(index, ind) {
            this.optimizations[index].projects.splice(ind, 1);
        },
        getProject(project, index, ind) {
            // console.log(project, index, ind)
            var obj = {
                projectname: project.name,
                projectid: project._id['$oid'],
            }
            this.optimizations[index].projects[ind] = obj;
            this.$forceUpdate()
        },
        addproject(index) {
            var optimization = this.optimizations[index];
            var obj = {projectname: '', projectid: ''};
            optimization.projects.push(obj);
        },
        getCityList() {
            this.$api.getCityList('').then(
                data=>{
                    this.regions = data;
                }
            )
        },
        getoptimizations() {
            var params = {
                id: this.acid
            }
            this.$api.getActivityoptimizations(params).then(
                data=>{
                    this.optimizations = data;
                }
            )
        },
        deleteop(item, index) {
            this.$confirm("是否确定删除").then(
                confirm=>{
                    this.optimizations.splice(index, 1);
                },
                cancel=>{}
            )
        },
        add() {
            if (!this.form.name) {
                this.$alert('缺少片区名称');
                return;
            }
            this.optimizations.push(this.form);
            this.form = {
                name: '',
                projects: [
                    {projectname: '', projectid: ''},
                    {projectname: '', projectid: ''},
                    {projectname: '', projectid: ''},
                    {projectname: '', projectid: ''},
                ],
                qrcode: '',
            };
        },
        confirm() {
            var params = {
                id: this.acid,
                optimizations: JSON.stringify(this.optimizations)
            }
            this.$api.setActivityoptimizations(params).then(
                data=>{
                    this.$message.success(data);
                    this.getoptimizations();
                    this.$store.commit('setshowoptimizationpicker', false);
                }
            )
        },
        close() {
            this.$confirm('编辑内容未保存是否确定关闭?')
                .then(_=>{
                    this.$store.commit('setshowoptimizationpicker', false);
                })
                .catch(_=>{})
        },
        handleAvatarSuccess(index,res) {
            let {data, msg} = res;
            if (data){
                this.$message.success(msg);
                this.optimizations[index].qrcode = data;
                this.$forceUpdate()
            } else {
                this.$message.error(msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner{
    height: 200px;
}
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.op-cell{
    ::v-deep .el-collapse-item__content{
        overflow: hidden;
        background: #f7f7f7;
    }
    ::v-deep .el-collapse-item__header{
        position: relative;
        .custom-input{
            width: 300px;
        }
        .del-btn{
            position: absolute;
            right: 40px;
        }
    }
    .project-box{
        position: relative;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        border-top: 1px solid #eee;
        overflow: hidden;
        .text{
            line-height: 32px;
            margin-top: 10px;
        }
        .addbtn{
             position: absolute;
             right: 0;
             top: 12px;
        }
        .project-warp{
            padding: 10px;
            background: #efefef;
            .project-cell{
                margin-bottom: 10px;
                .custom-input{
                    width: 300px;
                    margin-right: 10px;
                }
                .del-btn{
                    margin-left: 10px;
                }
            }
        }
    }
    .qr-box{
        margin-top: 10px;
    }
}
</style>